// Diete supportate — usate sia in AI Ricette che in Admin Catalog (form box)
export const DIETS = [
  { value: "onnivora", label: "Onnivora" },
  { value: "vegetariana", label: "Vegetariana" },
  { value: "vegana", label: "Vegana" },
  { value: "pescetariana", label: "Pescetariana" },
  { value: "mediterranea", label: "Mediterranea" },
  { value: "senza_glutine", label: "Senza glutine" },
  { value: "senza_lattosio", label: "Senza lattosio" },
  { value: "keto", label: "Chetogenica (Keto)" },
];

export const dietLabel = (v) => DIETS.find((d) => d.value === v)?.label || v;
